import { faBuilding, faMobile } from '@fortawesome/pro-regular-svg-icons';

import { ContactType, TContactType } from '@cloud-wave/neon-common-lib';
import { translate } from '@cloud-wave/neon-common-lib/app';

import DescriptivePills from 'lib/common/components/atoms/DescriptivePills';
import InfoPanel from 'lib/common/components/atoms/InfoPanel';

import getAllowedType from '../utils/getAllowedType';

export default function DirectoryContactType({
  type,
  setType,
  isAdmin,
  hasPersonalContactPermission,
  disabled,
}: {
  type: typeof ContactType.PERSONAL | typeof ContactType.ORGANISATION;
  setType: (type: typeof ContactType.PERSONAL | typeof ContactType.ORGANISATION) => void;
  isAdmin: boolean;
  hasPersonalContactPermission: boolean;
  disabled?: boolean;
}) {
  const allowedType = getAllowedType(isAdmin, hasPersonalContactPermission);

  if (allowedType === ContactType.PERSONAL) {
    return <InfoPanel>This will be a personal contact, only visible to you in your directory.</InfoPanel>;
  }

  if (allowedType === ContactType.ORGANISATION) {
    return (
      <InfoPanel>
        This will be an {translate('organisation')} contact, visible to everyone within your contact{' '}
        {translate('centre')}.
      </InfoPanel>
    );
  }

  return (
    <DescriptivePills
      ariaLabel="Contact type"
      pills={[
        {
          heading: 'Personal',
          selected: type === ContactType.PERSONAL,
          description: 'Only visible to you in your directory.',
          icon: faMobile,
          onClick: () => setType(ContactType.PERSONAL),
          disabled,
        },
        {
          heading: translate('Organisation'),
          selected: type === ContactType.ORGANISATION,
          description: `Visible to everyone within your contact ${translate('centre')}.`,
          icon: faBuilding,
          onClick: () => setType(ContactType.ORGANISATION),
          disabled,
        },
      ]}
    />
  );
}
